import { createAction } from '@reduxjs/toolkit';

export const AUTH_V2 = 'AUTH_V2';

const POST_SIGN_IN = `${AUTH_V2}/POST_SIGN_IN`;
const GET_SMS = `${AUTH_V2}/GET_SMS`;
const POST_PASSWORD_CHANGE = `${AUTH_V2}/POST_PASSWORD_CHANGE`;

export const userSignInAction = createAction<string>(POST_SIGN_IN);

export const authActionV2 = {
  POST_SIGN_IN,
  GET_SMS,
  POST_PASSWORD_CHANGE
};
